export const SELECT_ROW = '@client-shared/ui-agGrid/SELECT_ROW';
export const SELECT_ROW_BY_ROW_INDEX = '@client-shared/ui-agGrid/SELECT_ROW_BY_ROW_INDEX';
export const RESET_SELECTION_STATE = '@client-shared/ui-agGrid/RESET_SELECTION_STATE';
